/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Api_Drive_Access_DeniedInputs */

const fr_api_drive_access_denied = /** @type {(inputs: Api_Drive_Access_DeniedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`L’accès à Drive est refusé. Vérifiez les autorisations du compte connecté avec un administrateur.`)
};

const en_api_drive_access_denied = /** @type {(inputs: Api_Drive_Access_DeniedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Drive access was denied. Ask an administrator to check the connected account’s permissions.`)
};

/**
* | output |
* | --- |
* | "Drive access was denied. Ask an administrator to check the connected account’s permissions." |
*
* @param {Api_Drive_Access_DeniedInputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
export const api_drive_access_denied = /** @type {((inputs?: Api_Drive_Access_DeniedInputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Api_Drive_Access_DeniedInputs, { locale?: "fr" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_api_drive_access_denied(inputs)
	return fr_api_drive_access_denied(inputs)
});